import { useState, useEffect, useRef } from "react";
import {
  Typography,
  IconButton,
  TableContainer,
  Paper,
  Box,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CurrentOrdersList from "./currentOrdersList";
import getCurrentOrdersWithAnnotations from "../helpers/getCurrentOrdersWithAnnotations";

export default function CurrentOrders() {
  const [initData, setInitData] = useState([]);
  const initDataRef = useRef([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    initDataRef.current = initData;
  }, [initData]);

  useEffect(() => {
    getDeals();
  }, []);

  const getDeals = async () => {
    try {
      const newData = await getCurrentOrdersWithAnnotations(initDataRef);
      const { newData: annotatedData, updateTime } = newData;
      setInitData(annotatedData);
      setLastUpdated(updateTime);
      
    } catch (err) {
      console.error("Fetch error:", err);
    }
  }; 

  return (
    <div>
      <Box display="flex" alignItems="center" gap={2}>
      <Typography variant="body1" sx={{ mr: 0.5 }}>
          {`Current Orders (${initData.length})`}
        </Typography>
        <IconButton
          onClick={getDeals}
          color="primary"
          size="large"
          aria-label="refresh orders"
        >
          <RefreshIcon />
        </IconButton>
        {lastUpdated && (
          <Typography variant="body2" color="textSecondary">
            Updated: {new Date(lastUpdated).toLocaleTimeString()}
          </Typography>
        )}
      </Box>
       {initData.length > 0 ? (
        <TableContainer component={Paper}>
            <CurrentOrdersList data={initData} setData={setInitData} component={'currentOrders'}/>
        </TableContainer>
      ) : (
        <Typography>No ongoing deals.</Typography>
      )}
    </div>
  );
}
